import React from 'react'
import LoginForm from '../components/LoginForm'

const Login = () => {
  

  return (
    <div className='flex flex-row items-center justify-between w-full h-screen'>
        <LoginForm />
    </div>
  )
}

export default Login